<template>
  <section class="">
    <div v-for="(data, index) in faq" :key="index">
      <div class="py-10">
        <div class="flex justify-between">
          <div class="flex">
            <div
              class="font-bold text-5xl leading-14 text-gray-fossil opacity-50"
            >
              0{{ index + 1 }}
            </div>
            <div class="ml-12 font-bold text-3xl leading-10">
              {{ data.title }}
            </div>
          </div>
          <button
            v-if="buttonClicked === index + 1"
            class="focus:outline-none"
            @click="hideDescription(index + 1)"
          >
            <img
              :src="require(`@/assets/img/Cross.png`)"
              alt="Cross icon"
              class="rounded-lg"
            />
          </button>
          <button
            v-else
            class="focus:outline-none"
            @click="expandDescription(index + 1)"
          >
            <img
              :src="require(`@/assets/img/Plus.png`)"
              alt="Plus icon"
              class="rounded-lg"
            />
          </button>
        </div>
        <div
          v-if="buttonClicked === index + 1"
          class="ml-28 mt-6 font-medium text-2xl animate-slide-from-top text-gray-fossil opacity-75 tracking-wide mr-10 leading-7"
        >
          {{ data.description }}
        </div>
      </div>
      <div
        class="ring-gray-400 ring-1 opacity-25"
        v-if="index < faq.length - 1"
      ></div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      buttonClicked: "",
      faq: [
        {
          title: "What is Fitclass?",
          description:
            "An all-in-one online platform for anyone to find the perfect fitness class and for trainers to host fitness classes and build a business.",
        },
        {
          title: "Does Fitclass offer all levels of fitness?",
          description:
            "It offers classes for everyone, starting from beginners to advanced levels.",
        },
        {
          title: "Do I need special equipment?",
          description:
            "To get started no special equipment is required. Certain advanced classes may require equipment which could be mentioned by the trainer before beginning the class.",
        },
        {
          title: "Does Fitclass keep my data private?",
          description:
            "Yes, you are 100% safe with us. To know more checkout our privacy policy.",
        },
      ],
    };
  },
  methods: {
    expandDescription(id) {
      this.buttonClicked = id;
    },
    hideDescription(id) {
      this.buttonClicked = "";
    },
  },
};
</script>

<style scoped>
@keyframes slideFromTop {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.animate-slide-from-top {
  animation-name: slideFromTop;
  animation-fill-mode: forwards;
  animation-duration: 500ms;
  animation-timing-function: ease-in-out;
}
</style>
